// Mock data for AtoB Objektservice GmbH – "Ihre Berater rund um Immobilien"

export const companyInfo = {
  name: "AtoB Objektservice GmbH",
  slogan: "Ihre Berater rund um Immobilien",
  tagline: "Ein Netzwerk. Alle Immobilien-Fragen. Ein Ansprechpartner.",
  managing_director: "Admir Basic",
  phone: "+49 151 51488980",
  phone_office: "+49 2173 204 6452",
  email: "info@atob-objektservice.de",
  register: {
    court: "Amtsgericht Düsseldorf",
    number: "HRB 113625"
  },
  address: {
    street: "Schneiderstraße 63",
    city: "40764 Langenfeld",
    country: "Deutschland"
  }
};

// Kern-Beratungsleistungen
export const services = [
  {
    id: 1,
    title: "Kauf & Verkauf",
    tagline: "Marktwertermittlung & Vermarktung",
    description: "Von der Wertermittlung bis zum Notartermin: Wir begleiten Sie durch jeden Schritt und wählen aus unserem Netzwerk den passenden Vermarktungspartner – regional oder überregional, je nach Objekt.",
    icon: "Handshake",
    featured: true
  },
  {
    id: 2,
    title: "Finanzierung",
    tagline: "Über unser Bank-Netzwerk",
    description: "Wir bringen Sie mit den richtigen Ansprechpartnern in Banken und Finanzierungshäusern zusammen. Faire Konditionen, unabhängige Vergleiche, klare Sprache – ohne Fachchinesisch.",
    icon: "Landmark",
    featured: true
  },
  {
    id: 3,
    title: "Sanierung & Handwerk",
    tagline: "Geprüfte Betriebe aus der Region",
    description: "Malerei, Elektrik, Sanitär, Dach, Böden – wir vermitteln Handwerker, mit denen wir seit Jahren erfolgreich zusammenarbeiten. Koordination, Qualitätskontrolle und faire Kostenschätzung inklusive.",
    icon: "Hammer",
    featured: true
  },
  {
    id: 4,
    title: "Facility & Instandhaltung",
    tagline: "Laufende Betreuung Ihrer Immobilie",
    description: "Regelmäßige Objektbegehung, kleine Reparaturen, saubere Übergaben, Ansprechpartner vor Ort. Für Vermieter, Anleger und Eigentümer, die ihre Immobilie in ruhigen Händen wissen wollen.",
    icon: "ClipboardCheck",
    featured: true
  }
];

// Netzwerk-Kategorien (abstrakt, keine Partner-Namen)
export const networkPartners = [
  {
    id: 1,
    category: "Handwerk",
    icon: "Wrench",
    description: "Elektrik, Sanitär, Malerei, Dach, Bodenbeläge – geprüfte Meisterbetriebe mit langer Zusammenarbeit."
  },
  {
    id: 2,
    category: "Banken & Finanzierung",
    icon: "Landmark",
    description: "Etablierte Finanzierungspartner mit fairen Konditionen und persönlichen Ansprechpartnern."
  },
  {
    id: 3,
    category: "Hausverwaltung",
    icon: "Building2",
    description: "Erfahrene Verwalter für Wohn- und Anlageobjekte, WEGs und Mischnutzungen."
  },
  {
    id: 4,
    category: "Recht & Notar",
    icon: "Scale",
    description: "Fachanwälte für Immobilienrecht, Miet- und Erbrecht sowie Notare mit Immobilien-Schwerpunkt."
  },
  {
    id: 5,
    category: "Makler & Vermarktung",
    icon: "Home",
    description: "Regionale und überregionale Vermarktungspartner mit nachweislichem Track-Record."
  }
];

// Netzwerk-Prinzipien (warum das Netzwerk der USP ist)
export const networkPrinciples = [
  {
    id: 1,
    title: "Persönlich geprüft",
    description: "Jeder Partner ist von uns persönlich empfohlen – nicht algorithmisch vermittelt.",
    icon: "ShieldCheck"
  },
  {
    id: 2,
    title: "Unabhängig",
    description: "Wir vertreten Ihre Interessen, nicht die unserer Partner. Provisionen fließen nur bei Erfolg.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Ein Ansprechpartner",
    description: "Ein Telefonat, ein Ansprechpartner – wir koordinieren das gesamte Netzwerk für Sie.",
    icon: "Phone"
  },
  {
    id: 4,
    title: "Regionale Wurzeln",
    description: "Wir kennen die Region, die Behörden und den lokalen Immobilienmarkt aus eigener Erfahrung.",
    icon: "MapPin"
  }
];

// Case Studies (ersetzen die alte Vor-/Nachher-Galerie)
export const caseStudies = [
  {
    id: 1,
    title: "Mehrfamilienhaus, Solingen",
    category: "Verkauf & Sanierung",
    problem: "Erben wollten ein sanierungsbedürftiges MFH veräußern – ohne selbst zu koordinieren.",
    solution: "Wir haben Handwerker aus unserem Netzwerk mit den Vorarbeiten beauftragt, den Marktwert durch unseren Makler-Partner ermitteln und die Vermarktung steuern lassen.",
    result: "Verkauf über Marktwert in 6 Wochen. Erbengemeinschaft musste keinen einzigen Termin selbst koordinieren.",
    tags: ["Erbengemeinschaft", "Sanierung", "Verkauf"],
    accent: "orange"
  },
  {
    id: 2,
    title: "Anleger-Portfolio, Rhein-Kreis Neuss",
    category: "Verwaltung & Finanzierung",
    problem: "Kapitalanleger mit fünf Objekten wollte Portfolio strukturieren und günstigere Finanzierung.",
    solution: "Bestandsaufnahme aller Objekte, Modernisierungsplan mit Handwerks-Netzwerk, Anschlussfinanzierung über zwei Bankpartner verhandelt.",
    result: "0,7 % niedrigerer Zinssatz auf zwei Objekte. Laufende Verwaltung durch unser Team – Anleger spart 20 Std./Monat.",
    tags: ["Kapitalanleger", "Finanzierung", "Portfolio"],
    accent: "blue"
  },
  {
    id: 3,
    title: "Gewerbeimmobilie, Langenfeld",
    category: "Facility & Vermittlung",
    problem: "Eigentümer einer vermieteten Gewerbefläche brauchte verlässlichen Ansprechpartner vor Ort und rechtliche Beratung bei Mietanpassung.",
    solution: "Übernahme der Facility-Betreuung, Vermittlung an Fachanwalt für Gewerbemietrecht, Koordination der Instandhaltung mit unseren Handwerkern.",
    result: "Mietanpassung rechtssicher umgesetzt, jährliche Instandhaltungskosten um 18 % reduziert.",
    tags: ["Gewerbe", "Miete", "Facility"],
    accent: "orange"
  }
];

// FAQ – neu für Beratungspositionierung
export const faqData = [
  {
    id: 1,
    question: "Sind Sie Makler, Verwalter, Handwerker oder Bank?",
    answer: "Nichts davon direkt – und genau das ist der Punkt. Wir sind Ihre Berater und verfügen über ein geprüftes Netzwerk in allen relevanten Immobilien-Disziplinen. Wir bringen Sie mit dem richtigen Experten zusammen und koordinieren die Zusammenarbeit für Sie."
  },
  {
    id: 2,
    question: "Kostet die Erstberatung etwas?",
    answer: "Nein. Die erste Einschätzung ist immer kostenlos und unverbindlich – ob per Telefon, per E-Mail oder vor Ort. Erst wenn wir gemeinsam einen Weg definiert haben, sprechen wir über konkrete Kosten."
  },
  {
    id: 3,
    question: "Wer ist Ihre Zielgruppe?",
    answer: "Privateigentümer, Käufer, Verkäufer, Kapitalanleger und Gewerbetreibende – vor allem im Raum Solingen, Langenfeld, Düsseldorf, Haan, Hilden und Umgebung. Wir arbeiten aber auch überregional, wenn das Netzwerk gefragt ist."
  },
  {
    id: 4,
    question: "Wie unabhängig sind Sie von Ihren Partnern?",
    answer: "Wir sind ausschließlich Ihnen verpflichtet – nicht unseren Partnern. Unsere Empfehlungen erfolgen auf Basis nachweislicher Leistung. Provisionen fließen nur, wenn Sie mit dem Ergebnis zufrieden sind."
  },
  {
    id: 5,
    question: "Was, wenn ich nur einen guten Handwerker brauche?",
    answer: "Auch dafür sind wir da. Unser Handwerks-Netzwerk steht Ihnen auch für Einzelaufträge zur Verfügung – ob kleine Reparatur oder Komplettsanierung. Sie profitieren vom Preis, den wir als Volumenkunden verhandelt haben."
  },
  {
    id: 6,
    question: "Wie schnell erhalte ich eine Rückmeldung?",
    answer: "Werktags innerhalb von 24 Stunden. Bei Dringlichkeit auch am selben Tag – dafür haben wir unser Büro-Festnetz und eine Mobilnummer immer erreichbar."
  },
  {
    id: 7,
    question: "Betreuen Sie auch ganze Immobilien-Portfolios?",
    answer: "Ja. Von der laufenden Verwaltung einzelner Objekte bis zur strategischen Optimierung ganzer Portfolios für private und institutionelle Anleger. Sprechen Sie uns an – ein NDA ist selbstverständlich möglich."
  },
  {
    id: 8,
    question: "Warum ausgerechnet Ihr Netzwerk?",
    answer: "Weil es persönlich gewachsen ist. Wir haben mit unseren eigenen Immobilien angefangen und über Jahre die verlässlichen Partner gefunden – Handwerker, Banker, Anwälte, Verwalter. Sie profitieren vom kompletten Netzwerk, ohne selbst mühsam Kontakte aufbauen zu müssen."
  }
];

// Stats – repositioniert
export const stats = [
  {
    id: 1,
    value: "5",
    label: "Netzwerk-Bereiche",
    icon: "Network"
  },
  {
    id: 2,
    value: "50+",
    label: "Geprüfte Partner",
    icon: "Users"
  },
  {
    id: 3,
    value: "24h",
    label: "Reaktionszeit",
    icon: "Zap"
  },
  {
    id: 4,
    value: "100%",
    label: "Ihre Interessen",
    icon: "Award"
  }
];

// Not used anymore but kept to prevent import errors elsewhere:
export const features = [];
export const testimonials = [];
export const galleryImages = [];
